import React, { useState, useEffect, useRef } from 'react';
import speak from '../speak';

const colors = [
    { name: "Black", code: "#000000" },
    { name: "White", code: "#FFFFFF" },
    { name: "Red", code: "#FF0000" },
    { name: "Brown", code: "#A52A2A" },
    { name: "Green", code: "#008000" },
    { name: "Blue", code: "#0000FF" },
    { name: "Yellow", code: "#FFFF00" },
    { name: "Purple", code: "#800080" },
    { name: "Orange", code: "#FFA500" },
    { name: "Cyan", code: "#00FFFF" },
    { name: "Magenta", code: "#FF00FF" },
    { name: "Lime", code: "#00FF00" },
    { name: "Pink", code: "#FFC0CB" }
];

function randomIndex(length, exclude) {
  let idx;
  do { idx = Math.floor(Math.random() * length); } while (idx === exclude && length > 1);
  return idx;
}

function ColorChangingSquare({ speed = 10000, audioEnabled = false }) {
  const [color, setColor] = useState(() => colors[Math.floor(Math.random() * colors.length)]);
  const [boxSize, setBoxSize] = useState('25vw');
  const audioRef = useRef(audioEnabled);
  const colorIndexRef = useRef(null);

  useEffect(() => {
    audioRef.current = audioEnabled;
  }, [audioEnabled]);

  useEffect(() => {
    const interval = setInterval(() => {
      const idx = randomIndex(colors.length, colorIndexRef.current);
      colorIndexRef.current = idx;
      const newColor = colors[idx];
      setColor(newColor);
      if (audioRef.current) speak(newColor.name);
    }, speed);

    return () => clearInterval(interval);
  }, [speed]);

  useEffect(() => {
    const resizeListener = () => {
      const size = Math.min(window.innerWidth, window.innerHeight) * 0.25 + 'px';
      setBoxSize(size);
    };

    window.addEventListener('resize', resizeListener);
    resizeListener(); // Call initially to set size

    return () => {
      window.removeEventListener('resize', resizeListener);
    };
  }, []);

  return (
    <div className="flex flex-col justify-center items-center h-screen bg-gray-100">
      <div style={{ width: boxSize, height: boxSize, backgroundColor: color.code }}
           className="flex justify-center items-center">
      </div>
      <p id="colorName" className="mt-5 text-xl text-gray-800">{color.name}</p>
    </div>
  );
}

export default ColorChangingSquare;
